import styled from 'styled-components';
import { Center, ColumnCenter, Props as FlexProps } from '@/components/Flex';
import Title from '@/components/text/Title';
import { MEDIA_QUERY_TABLET } from '@/configs/mediaQuery';
import { GapProps, MarginProps, PaddingProps, SizeProps } from '@/types/ui';
import {
  getMarginStyle,
  getPaddingStyle,
  getSizeStyle,
} from '@/utils/style/ui';

interface StyleProps {
  isSmall?: boolean;
  justify?: FlexProps['$justify'];
  gap?: GapProps;
  width?: SizeProps;
  maxWidth?: SizeProps;
  height?: SizeProps;
  margin?: MarginProps;
  padding?: PaddingProps;
}

export interface Props extends StyleProps, React.PropsWithChildren {
  title?: React.ReactNode;
}

const Root = styled(ColumnCenter)<StyleProps>`
  ${({ justify }) => (justify ? `justify-content: ${justify};` : '')}
  ${({ theme, gap }) =>
    getSizeStyle({ theme, size: gap, key: 'gap' }) || 'gap: 48px;'}
  width: ${({ theme, isSmall, width }) =>
    isSmall ? '656px' : getSizeStyle({ theme, size: width }) || '1080px'};
  max-width: ${({ theme, maxWidth }) =>
    getSizeStyle({ theme, size: maxWidth }) || '100%'};
  height: ${({ theme, height }) =>
    getSizeStyle({ theme, size: height }) || 'unset'};
  ${({ theme, padding }) =>
    getPaddingStyle({
      theme,
      padding,
      defaultValue: 'zero',
    })}
  ${({ theme, margin }) =>
    getMarginStyle({
      theme,
      margin,
      defaultValue: 'zero',
    })}

  @media (${MEDIA_QUERY_TABLET}) {
    width: ${({ theme, width }) =>
      getSizeStyle({ theme, size: width }) || 'unset'};
    min-width: ${({ theme, width }) =>
      getSizeStyle({ theme, size: width }) || 'unset'};
  }
`;

export default function Section({ title, children, ...props }: Props) {
  return (
    <Root {...props}>
      {title ? (
        <Title $textAlign="center">
          <Center $gap="xs">{title}</Center>
        </Title>
      ) : (
        ''
      )}
      {children}
    </Root>
  );
}
